/** Class level dropdown: LKG, UKG, then 1–10 */
export const CLASS_LEVEL_OPTIONS = [
  { value: 'lkg', label: 'LKG' },
  { value: 'ukg', label: 'UKG' },
  ...Array.from({ length: 10 }, (_, i) => {
    const n = String(i + 1);
    return { value: n, label: n };
  }),
];

export function isValidClassLevel(value) {
  const s = String(value ?? '').trim().toLowerCase();
  if (s === 'lkg' || s === 'ukg') return true;
  const n = parseInt(s, 10);
  return !Number.isNaN(n) && n >= 1 && n <= 10;
}

export function classLevelPrefix(value) {
  const s = String(value ?? '').trim().toLowerCase();
  if (s === 'lkg' || s === 'ukg') return s.toUpperCase();
  const n = parseInt(s, 10);
  if (!Number.isNaN(n) && n >= 1 && n <= 10) return String(n);
  return '';
}

/** LKG/UKG + division use a space (e.g. "LKG A"); grades 1–10 stay compact (e.g. "1A"). */
export function buildDivisionName(classLevel, divisionLetter) {
  const prefix = classLevelPrefix(classLevel);
  const suffix = String(divisionLetter ?? '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
  if (!prefix || !suffix) return '';
  if (prefix === 'LKG' || prefix === 'UKG') {
    return `${prefix} ${suffix}`;
  }
  return `${prefix}${suffix}`;
}
